import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { S3Command } from 'lib_ts/enums/data.enums';
import { AwsRegion } from 'lib_ts/enums/s3.enum';
import { compact } from 'lodash';
import { useEffect } from 'react';
import { HittersService } from 'services/hitters.service';
import { useAuthStore } from 'stores/use-auth-store';
import useHittersStore from 'stores/use-hitters-store';
import useSignedUrlsStore from 'stores/use-signed-urls-store';

// ensures the players in store match what the user has access to
const useSyncHitters = () => {
  const current = useAuthStore((s) => s.current);
  const lastChanged = useHittersStore((s) => s.lastChanged);

  /** reload data to match session access */
  useEffect(() => {
    if (!current.auth) {
      return;
    }

    if (!current.session) {
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        useHittersStore.setState({ loading: true });

        const players = await HittersService.getInstance().getHitters();

        const avatarPaths = ArrayHelper.unique(
          players.map((h) => h.avatar_path ?? '')
        );

        if (avatarPaths.length > 0) {
          await useSignedUrlsStore.getState().fetchSignedUrls(
            compact(
              players.map((m) =>
                m.avatar_path
                  ? {
                      path: m.avatar_path,
                      region: m.avatar_region ?? AwsRegion.CA,
                    }
                  : undefined
              )
            ),
            S3Command.getObject
          );
        }

        useHittersStore.setState({ hitters: players });
      } catch (e) {
        console.error(e);
      } finally {
        useHittersStore.setState({ loading: false });
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [current.auth, current.session, lastChanged]);
};

export default useSyncHitters;
